import React from 'react';
import PropTypes from 'prop-types';
import { EmptyStateSVG } from '../assets';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
const EmptyList = _ref => {
  let {
    emptyListCallback = () => {}
  } = _ref;
  const emptyList = emptyListCallback();
  return /*#__PURE__*/React.createElement("div", {
    "data-naos-element": "explorer-empty-state",
    className: treeStyles['sib-tree-view__exp-empty']
  }, /*#__PURE__*/React.createElement(EmptyStateSVG, null), emptyList);
};
EmptyList.propTypes = {
  emptyListCallback: PropTypes.func
};
export default EmptyList;